export default __webpack_public_path__ + "static/media/church_aerial.e12e67a5.jpeg";